import { ClientProfileViewModel } from '@common/model/client';
import { SxProps } from '@cp/ds/src/theme';
import { ModerationToggle, ModerationToggleVariant } from 'src/features/moderation/moderationToggle';
import { coreClientProfileApi } from 'src/entities/clientProfile';

export const ToggleClientWorking = ({
  clientProfile,
  variant = 'default',
  sx,
}: {
  clientProfile?: ClientProfileViewModel;
  variant?: ModerationToggleVariant;
  sx?: SxProps;
}) => {
  const [toggleClientWorking] = coreClientProfileApi.endpoints.toggleClientWorking.useMutation();

  return (
    <ModerationToggle
      checked={clientProfile?.isWorking ?? false}
      disabled={!clientProfile}
      label="Работаю"
      onChange={() => {
        if (!clientProfile) return;
        toggleClientWorking({ clientId: clientProfile.id });
      }}
      sx={sx}
      variant={variant}
    />
  );
};
